export  const AdTagType = {
  VAST: 'vast',
  VMAP: 'vmap'
} as const;
